module.exports = __webpack_public_path__ + "media/images/icon-resource-publication-91123a77a6f5771e2c17ca0ca2aa4ae8.png";